import { useQuery } from "react-query";
import type { BasePaywallPrice } from "@/react/types/PaywallPrice";
import { workflows } from "@circle-react/helpers/urlHelpers/internalApi/workflows";

// Extend BasePaywallPrice with additional fields that come from the API response
type PaywallPriceResponse = BasePaywallPrice & {
  paywall_display_name?: string;
  paywall_name?: string;
};

export const useFetchPaywallPrice = ({
  paywallId,
  priceId,
}: {
  paywallId: string;
  priceId: string;
}) => {
  const {
    data: paywallPrice,
    isLoading,
    isSuccess,
  } = useQuery(
    workflows.paywallPrices.show({
      paywallId: paywallId,
      id: priceId,
    }),
  );

  return {
    paywallPrice: paywallPrice as PaywallPriceResponse | undefined,
    isLoading,
    isSuccess,
  };
};
